"use client";

import { components } from "react-select";

import FilterDropdown from "@/components/ui/FilterDropdown";


const ColorOption = (props: any) => {
  const option = props.data;

  return (
    <components.Option {...props}>
      <div className="flex items-center gap-2">
        {option.hexCode && (
          <span
            className="inline-block h-4 w-4 flex-shrink-0 rounded-full border border-gray-300"
            style={{ backgroundColor: option.hexCode }}
            aria-label={`${option.label} color`}
          />
        )}
        <span>{option.label}</span>
      </div>
    </components.Option>
  );
};

const ColorSingleValue = (props: any) => {
  const option = props.data;

  return (
    <components.SingleValue {...props}>
      <div className="flex items-center gap-2">
        {option.hexCode && (
          <span
            className="inline-block h-4 w-4 flex-shrink-0 rounded-full border border-gray-300"
            style={{ backgroundColor: option.hexCode }}
            aria-label={`${option.label} color`}
          />
        )}
        <span>{option.label}</span>
      </div>
    </components.SingleValue>
  );
};

const ColorMultiValue = (props: any) => {
  const option = props.data;

  return (
    <components.MultiValue {...props}>
      <div className="flex items-center gap-1.5">
        {option.hexCode && (
          <span
            className="inline-block h-3 w-3 flex-shrink-0 rounded-full"
            style={{ backgroundColor: option.hexCode }}
            aria-label={`${option.label} color`}
          />
        )}
        <span>{option.label}</span>
      </div>
    </components.MultiValue>
  );
};

interface ColorFilterDropdownProps<T> {
  options: Array<{ value: T; label: string; hexCode?: string }>;
  id: string;
  helperText: string;
  withLabel?: boolean;
  onSelect: (option: any) => void;
  onClear?: () => void;
  value: { value: T; label: string; hexCode?: string } | Array<{ value: T; label: string; hexCode?: string }> | null;
  isLoading?: boolean;
  isSearchable?: boolean;
  isDisabled?: boolean;
  isMulti?: boolean;
  menuPlacement?: "top" | "bottom";
  customClassNames?: any;
}

export default function ColorFilterDropdown<T>(props: ColorFilterDropdownProps<T>) {
  return (
    <FilterDropdown
      {...props}
      customComponents={{
        Option: ColorOption,
        SingleValue: ColorSingleValue,
        MultiValue: ColorMultiValue,
      }}
    />
  );
}
